import * as React from 'react';
import Table from "@mui/material/Table";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { Direction } from './types';
import { HorizontalTableBody } from './components/HorizontalTableBody';
import { VerticalTableBody } from './components/VerticalTableBody';
import * as styles from './CustomBaseTable.style';
export const extraStyle = (initialStyle, extraStyle) => {
    let returnedStyle = Object.assign({}, initialStyle);
    if (extraStyle) {
        returnedStyle = Object.assign(Object.assign({}, returnedStyle), extraStyle);
    }
    return returnedStyle;
};
export const CustomBaseTable = (props) => {
    const { columns, dataQa = 'base-table', direction = Direction.VERTICAL, selected } = props;
    return (React.createElement(TableContainer, { "data-qa": dataQa, sx: styles.table },
        React.createElement(Table, null,
            direction === Direction.VERTICAL && (React.createElement(TableHead, { "data-qa": `${dataQa}-head` },
                React.createElement(TableRow, null, columns.map((c, index) => (React.createElement(TableCell, { key: `verticalHead-${index}`, sx: extraStyle(styles.tableHeadCell(index !== columns.length - 1, selected === c.key), c.extraStyle), variant: "head" }, c.title)))))),
            direction === Direction.VERTICAL
                ? (React.createElement(VerticalTableBody, Object.assign({}, props, { dataQa: dataQa }))) : (React.createElement(HorizontalTableBody, Object.assign({}, props, { dataQa: dataQa }))))));
};
